import axios from "axios";
import { apiURI, authErrorRedirect } from "../../common";

export async function handleSendReceiverData(
  setErrors,
  setIsSubmitting,
  supplierValues,
  data,
  sampleRequestID,
  sampleItemID,
  sampleDetails,
  setReloadData,
  history
) {
  setErrors({});
  // Start loading state
  setIsSubmitting(true);

  // Filter out current supplier data
  const newArr = supplierValues.filter(
    (obj) => obj.qualityReportsID !== data.qualityReportsID
  );
  // Prepare data to send to the server
  let sampleData = {
    sampleRequestID: sampleRequestID,
    sampleItemID: sampleItemID,

    suppliers: [
      {
        ...sampleDetails,
        dateModified: Date.now(),
        deliveredDate: Date.now(),
      },
      ...newArr,
    ],
  };

  // Send data to the server using axios
  await axios
    .post(`${apiURI}/form/addReceiverDetails`, sampleData)
    .then(() => {
      // Reset loading state
      setIsSubmitting(false);
      // Trigger reload of data after successful submission
      setReloadData(true);
    })
    .catch((response) => {
      console.log("error in axios form call react");
      // Clear errors
      setErrors({});
      // Set errors received from server response
      setErrors(response.response.data);
      // Redirect on authentication error
      authErrorRedirect(response.response.data, history);
    });

  // eslint-disable-next-line no-console
}
